import { createFileRoute } from '@tanstack/react-router'

import { SettingsIndexPage } from '@/pages/settings/SettingsIndexPage'

export const Route = createFileRoute('/_authenticated/_dashboard/settings/')({
  component: SettingsIndexPage,
})
